import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

import loadingGif from '../assets/loading.gif';
import { glassStyles } from '../theme';

const Loading = ({ message = 'Loading...', fullScreen = true }) => {
  const content = (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          sx={{
            ...glassStyles.card,
            p: 3,
            borderRadius: '50%',
            overflow: 'hidden',
          }}
        >
          <img
            src={loadingGif}
            alt="Loading"
            style={{
              width: 120,
              height: 120,
              objectFit: 'cover',
              borderRadius: '50%',
            }}
          />
        </Box>
        <Typography
          variant="body1"
          sx={{
            color: 'text.secondary',
            fontWeight: 500,
          }}
        >
          {message}
        </Typography>
      </Box>
    </motion.div>
  );

  if (fullScreen) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {content}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        py: 6,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      {content}
    </Box>
  );
};

export default Loading;
